<template>
<div>

  <!-- PC -->
  <div class="banner_box">
    <!-- 背景图片 -->
    <div class="banner"></div>
    <!-- 登入、申請成為商家 -->
    <div class="user_box" v-show="userLoginContentShow">
      <div class="user_login" @click="login()">
        <span class="icon_user_login">商家登入</span>
      </div>
      <!-- 掃碼登入 -->
      <div class="code_login" @click="showFun()">
        <span class="icon_code_login" >掃碼登入</span>
        <div v-show="codeShow" class="code_login_content"></div>
      </div>
      <!-- 申請成為商家 -->
      <div class="merchant" @click="register()">
        <span class="icon_merchant">申請成為商家</span>
      </div>
    </div>
    <!-- 個人用戶請點此 -->
    <div class="individual_box">
      <router-link tag="div" class="individual" to="/">
        <span class="icon_individual"></span><div class="personage">個人用戶請點此</div> 
      </router-link>
    </div>
    <!-- 登入框内容 -->
    <div v-show="!userLoginContentShow" class="user_login_content_box">
      <div class="user_login_content">
        <!-- 1 -->
        <div class="user_login_step01" v-show="!userLoginStepShow">
          <div class="login_content_user">
            帳號：<input type="text" placeholder="請輸入用戶名" v-model="user" key="user" @keyup.enter="loginGoogle()">
          </div>
          <div class="login_content_pass">
            密碼：<input type="password" placeholder="請輸入密碼" v-model="password" key="password" @keyup.enter="loginGoogle()">
          </div>
        </div>
        <!-- 2 -->
        <div class="user_login_step02" v-show="userLoginStepShow">
          <div class="user_two">
            <p>{{user}}</p>
            <p>****************</p>
          </div>
          <!-- 后端交互 -->
          <div class="login_content_google">
            GOOGLE驗證碼：<input type="text" v-model="googleVerification" key="google">
          </div>
        </div>
        <el-button class="loginGoogle" @click="loginGoogle()" :loading="loginLoading">登入台易購商家系統</el-button>
        <!--  -->
        <div class="login_help">
          <div @click="register()">註冊為商家</div>
          <p>｜</p>
          <div v-if="!userLoginStepShow" @click="forget()">忘記密碼?</div>
          <div v-else>無法取得GOOGLE驗證碼？</div>
        </div>
      </div>
    </div>
  </div>
  <!-- PC-END -->

  <!-- PHONE -->
  <div class="phone_banner_box">
    <!-- 1 -->
    <div class="p_banner">
      <!-- 登入、申請成為商家 -->
      <div class="user_box" v-show="userLoginContentShow">
        <div class="user_login"  @click="login()">
          <span class="icon_user_login"><img src="../../../assets/img/home/icon_user_login.png" alt="" srcset="">商家登入</span>
        </div>
        <!-- 掃碼登入 -->
        <div class="code_login" @click="showFun()">
          <span class="icon_code_login" ><img src="../../../assets/img/home/icon_code_login.png" alt="" srcset="">掃碼登入</span>
          <!-- <div v-show="codeShow" class="code_login_content"></div> -->
        </div>
        <!-- 申請成為商家 -->
        <div class="merchant" @click="register()">
          <span class="icon_merchant"><img src="../../../assets/img/home/icon_merchant.png" alt="" srcset="">申請成為商家</span>
        </div>
      </div>

    </div>
    <!-- 2 -->
    <div class="p_nav_box">
      <!--  -->
      <a @click="goHome()">首頁</a>
      <router-link to="/product">產品</router-link>
      <router-link to="/partner">合作夥伴</router-link>
      <router-link to="/developer">開發人員</router-link>
      <a @click="goTest()">常見問題</a>
      <router-link to="/contact">聯絡我們</router-link>
    </div>
    
    <!-- 登入框内容 -->
    <div v-show="!userLoginContentShow" class="user_login_content_box">
      <div class="user_login_content">
        <!-- 1 -->
        <div class="user_login_step01" v-show="!userLoginStepShow">
          <div class="login_content_user">
            帳號：<input type="text" placeholder="請輸入用戶名" v-model="user" key="user" @keyup.enter="loginGoogle()">
          </div>
          <div class="login_content_pass">
            密碼：<input type="password" placeholder="請輸入密碼" v-model="password" key="password" @keyup.enter="loginGoogle()">
          </div>
        </div>
        <!-- 2 -->
        <div class="user_login_step02" v-show="userLoginStepShow">
          <div class="user_two">
            <p>{{user}}</p>
            <p>****************</p>
          </div>
          <!-- 后端交互 -->
          <div class="login_content_google">
            GOOGLE驗證碼：<input type="text" v-model="googleVerification" key="google">
          </div>
        </div>
        <el-button class="loginGoogle" @click="loginGoogle()" :loading="loginLoading">登入台易購商家系統</el-button>
        <!--  -->
        <div class="login_help">
          <div @click="register()">註冊為商家</div>
          <p>｜</p>
          <div v-if="!userLoginStepShow" @click="forget()">忘記密碼?</div>
          <div v-else>無法取得GOOGLE驗證碼？</div>
        </div>
      </div>
    </div>
    <!-- 登入框内容-END -->

  </div>
  <!-- PHONE-END -->

</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HomeBanner',
  props: {
  },
  data() {
    return {
      codeShow: false,
      loginLoading: false,
      userLoginContentShow: true,
      userLoginStepShow: false,
      user: "",
      password: "",
      googleVerification: "",
      message: 0,
      status: false
    }
  },
  methods: {
    showFun() {
      this.codeShow = !this.codeShow;
    },
    login(){
        this.userLoginContentShow = !this.userLoginContentShow;
    },
    // FUN-Google验证码ajax请求
    axiosGoogle(){
      axios.get(this.$store.state.axiosGoogleUrl, {
        params:{
          code: this.googleVerification
        }
      }).then((res) => {
        this.loginLoading = false;
        this.message = res.data.message;
        // 正确
        if(this.message == 1){
            this.$message({
              showClose: true,
              message: '驗證成功，歡迎您登入台易購商城',
              type: 'success',
              duration: 1000
            });
          this.$router.push("/login");
        }
        // 错误
        if(this.message == -1){
          this.$message({
            showClose: true,
            message: '您輸入的google驗證碼錯誤',
            type: 'error',
            duration: 1000
          });
        }
      })
    },
    // FUN-登入-发送ajax请求
    axiosGet(){
      axios.get(this.$store.state.axiosGetUrl, {
        params:{
          username: this.user,
          password: this.password
        }
      }).then((res) => {
        // Loading:
        this.loginLoading = false;
        this.message = res.data.message;
        this.stage = res.data.message.stage;
        this.status = res.data.status;
        // 登入失败
        if(!this.status){
          // 根据message值得不同，判断
          if(this.message == -1){
            this.$message({
              showClose: true,
              message: '用戶名或密碼有誤，請重新輸入',
              type: 'error',
              duration: 1000
            });
          } else {
            this.$message({
              showClose: true,
              message: this.message,
              type: 'error',
              duration: 1000
            });
          }
        }
        // 登入成功
        if( this.status){
            // console.log(res.data.message);
            // res.data.message.change_branch_status
            
            // Cun：
            localStorage.setItem('user', this.user);
            localStorage.setItem('pass', this.password);

            // 判断是否有注册
            if(this.stage){
              this.$router.push("/register");
              this.changeRegister({
                stage: this.stage,
                registerList: res.data.message.list,
              })

            } else {
              this.$message({
                showClose: true,
                message: '歡迎您登入台易購商城',
                type: 'success',
                duration: 1000
              });

              sessionStorage.setItem("Flag", "isLogin");
              // 全局-記錄-uid/uidTF
              this.recordUid({
                reserved:res.data.message.reserved,
                secretTF:res.data.message.secret,
                secretVal:res.data.message.secret_value,
                dealTF: res.data.message.status,
                settledTF: res.data.message.settled_status,
                telephone: res.data.message.telephone,
                traderPassTF:res.data.message.trader_password,
                uid: res.data.message.uid,
                agreement: res.data.message.use_status,
                username: res.data.message.username,
                principal: res.data.message.principal,
                branchChange: res.data.message.change_branch_status,
                is_agent: res.data.message.is_agent
              });

              // 判斷銀行狀態問題：
              if(res.data.message.change_branch_status == 0){
                // 0:
                if(this.message.username == 1){
                  // 未绑定Google用户，等待一秒登入
                  setTimeout(() => {
                    this.$router.push("/login/agreement");
                  },1000);

                } else {
                  // 绑定Google用户
                  this.userLoginStepShow = true;

                }

              } else {
                // 1-2:
                this.$router.push("/login/loginaudit");
                // 修改結算資訊：
                localStorage.setItem("Baudit", "isBranch");
              }

            }
        }
      });
    },
    // FUN-全局-記錄-uid/uidTF
    changeRegister(register){
       this.$store.commit('changeRegister',register);
    },
    // FUN-全局-記錄注册状态-stage；
    recordUid(uid){
       this.$store.commit('changeUid',uid);
    },
    loginGoogle(){
      // this.$router.push("/login");
      // 请输入用户名
      if(this.user == ""){
        this.$message({
          showClose: true,
          message: '請輸入用戶名',
          type: 'error',
          duration: 1000
        });
        return
      }
      // 请输入密码
      if(this.password == ""){
        this.$message({
          showClose: true,
          message: '請輸入密碼',
          type: 'error',
          duration: 1000
        });
        return
      }
      // 判斷是否需要google驗證碼
      if(this.userLoginStepShow){
        if(this.googleVerification == ''){
          this.$message({
            showClose: true,
            message: '請輸入google驗證碼',
            type: 'warning',
            duration: 1000
          });
          return
        }
        // Google验证码ajax请求
        this.axiosGoogle();
      } else {
        // 发送ajax请求
        this.loginLoading = true;
        this.axiosGet();
      }
    },
    register() {
      this.$router.push("/register");
    },
    forget() {
      this.$router.push("/forget");
    }


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* CSS-PC */
@media screen and (min-width:769px){

  .banner_box {
    position: relative;
  }
  /* 背景图片 */
  .banner {
    box-sizing: border-box;
    border-top: 4px solid  #e73262;
    height: 400px;
    background: url("../../../assets/img/home/banner.jpg") center repeat-x;
  }
/* 登入、申請成為商家 */
  .user_box {
    font-size: 13px;
    letter-spacing: 1px;
    position: absolute;
    bottom: 120px;
    left: 50%;
    margin-left: -364px;
    min-width: 728px;
    display: flex;
    justify-content: center;

  }
   .user_box >div {
    cursor:pointer;
    margin-right: 38px;
    float: left;
    padding: 12px 26px;
    border-radius: 16px;
    background: #e73262;
    color: #ffffff;
  }
  .icon_user_login {
    height: 23px;
    line-height: 23px;
    background: url("../../../assets/img/home/icon_user_login.png") no-repeat;
    background-size: contain;
    padding-left: 20px;
  }
  /* 掃碼登入 */
  .code_login {
    position: relative;
  }
  .code_login .code_login_content {
    position: absolute;
    bottom: -132px;
    left: 50%;
    width: 130px;
    height: 130px;
    background: url("../../../assets/img/home/code_login.png") no-repeat center;
    background-size: contain;
    margin: 0;
    margin-left: -65px;
    padding: 0;
    border-radius: 0;
  }
  .icon_code_login {
    height: 23px;
    line-height: 23px;
    background: url("../../../assets/img/home/icon_code_login.png") no-repeat;
    background-size: contain;
    padding-left: 20px;
  }
  .user_box .merchant {
    background: #ffffff;
    color: #2c1e30;
    margin-right: 0px;
  }
  .merchant .icon_merchant {
    height: 23px;
    line-height: 23px;
    background: url("../../../assets/img/home/icon_merchant.png") no-repeat;
    background-size: contain;
    padding-left: 20px;
  }
/* 個人用戶請點此 */
  .individual_box {
    font-size: 13px;
    height: 56px;
    background: linear-gradient(#083340, #0c1e1e);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
  }
  .individual {
    display: block;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: #ffffff;
    padding: 1px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ffffff;
  }
  .individual .personage {
    padding-left: 10px;
    font-size: 13px;
    text-align: center;
    
  }
  .individual_box .icon_individual {
    height: 18px;
    width: 18px;
    display: block;
    background: url("../../../assets/img/home/individual.png") center no-repeat;
    background-size: contain;
  }
  .loginGoogle {
    cursor:pointer;
    border: none;
  }
/* 登入内容 */
  .user_login_content_box {
    width: 580px;
    height: 162px;
    position: absolute;
    bottom: 60px;
    left: 50%;
    margin-left: -290px;
    background: rgba(0,0,0,.3);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
   .user_login_content_box .user_login_content {
     overflow: hidden;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
  }
  .user_login_content > div, button {
    margin: 10px 0vw;
  }  
  .user_login_content_box input {
    background: transparent;
    color: white;
    border-bottom: 2px solid white;
    flex: 1;
  }
  .user_login_content_box .login_content_user, .user_login_content_box .login_content_pass {
    display: flex;
    min-width: 270px;
    margin: 4px;
    justify-content: center;
    align-items: center;
  }
  .user_login_content_box button {
    padding: 6px 80px;
    background: #e73262;
    font-weight: bold;
    color: white;
    border-radius: 12px;
  }
  .user_login_content .login_help {
    display: flex;
    font-size: 11px;
    color: #56a2ff;
  }
  .user_login_content .login_help > div, .user_login_content .login_help > p {
    margin: 0vw 3px;
  }
  .user_login_content .login_help > div {
    padding-bottom: 6px;
    border-bottom: 1px solid #56a2ff;
  }
  .user_two {
    display: flex;
    justify-content: space-around;
    margin-bottom: 14px;
  }
  .login_help {
    cursor:pointer;
  }
  /* PC/PHONE-显示/隐藏 */
  .phone_banner_box {
    display: none;
  }


}




/* CSS-PHONE */
@media screen and (max-width:768px){
  /* PC/PHONE-显示/隐藏 */
  .banner_box {
    display: none;
  }
  .phone_banner_box {
  display: block;
  border-top: .7vw solid  #e73262;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.p_banner {
  background: url("../../../assets/img/index/tyg_banner.jpg") center repeat-x;
  background-size: cover;
  height: 46.7vw;
  position: relative;
}
.p_banner .user_box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 32vw;
}
.p_banner .user_box >div {
  box-sizing: border-box;
  background: #e73262;
  color: white;
  font-size: 2.3vw;
  padding: 1.7vw 3.7vw;
  border-radius: 1.3vw;
}
.p_banner .user_box >div+div {
  margin-left: 4vw;
}
.p_banner .user_box .merchant {
  box-sizing: border-box;
  background: white;
  color: #291c2e;
  padding: 1.7vw 3.7vw;
  border-radius: 1.3vw;
}
.p_banner .user_box >div >span {
  display: flex;
  align-items: center;
  font-size: 2.2vw;
}
.icon_user_login img {
  width: 2.8vw;
  margin-right: .6vw;
}
.icon_code_login img {
  width: 2.8vw;
  margin-right: .6vw;
}
.icon_merchant img {
  width: 2.8vw;
  margin-right: .6vw;
}

.p_nav_box {
  background: linear-gradient(#083340, #0c1e1e);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6.7vw;
  /* height: 50px; */
}
.p_nav_box >a {
  box-sizing: border-box;
  padding: 0 2.3vw;
  font-size: 2.8vw;
  color: white;
  text-align: center;
}
.p_nav_box >a+a {
  border-left: 2px solid white;
}
/* 登入内容 */
  .user_login_content_box {
    overflow: hidden;
    width: 77vw;
    position: absolute;
    bottom: 9.8vw;
    left: 50%;
    margin-left: -38.5vw;
    background: rgba(0,0,0,.3); 
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .user_login_content_box .user_login_content {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .user_login_content > div, button {
    margin: 1vw 0vw;
  }  
  .user_login_content_box input {
    background: transparent;
    color: white;
    
    border-bottom: 2px solid white;
    flex: 1;
  }
  .user_login_content_box .login_content_user, .user_login_content_box .login_content_pass {
    display: flex;
    min-width: 36vw;
    margin: 2px 0;
    justify-content: center;
    align-items: center;
  }
  .user_login_content_box button {
    /* padding: 6px 10.7vw; */
    border: #e73262;
    background: #e73262;
    font-weight: bold;
    color: white;
    border-radius: 12px;
  }
  .user_login_content .login_help {
    display: flex;
    color: #56a2ff;
  }
  .user_login_content .login_help > div, .user_login_content .login_help > p {
    /* margin: 0vw 3px; */
  }
  .user_login_content .login_help > div {
    padding-bottom: 6px;
    border-bottom: 1px solid #56a2ff;
  }
  .user_two {
    display: flex;
    justify-content: space-around;
    margin-bottom: 14px;
  }
  .login_help {
    cursor:pointer;
  }
  /* 登入修改 */
  .user_login_content_box .loginGoogle {
    font-size: 2.3vw;
  }


}

</style>
